import {AmsDataGridCellRenderParams, AmsDataGridColumnDef} from "../framework/component/data-grid/AmsDataGrid";
import {CollaboratorListing} from "./model/CollaboratorListing";
import React from "react";
import {CollaboratorStatus} from "./model/CollaboratorStatus";
import {CollaboratorTypesByValue} from "./model/CollaboratorType";

const headerClassName = 'grid-header';

export const collaboratorListColumns: AmsDataGridColumnDef[] = [
  {
    field: 'researcherId',
    headerName: 'Researcher ID',
    width: 150,
    filterable: false,
    headerClassName: headerClassName,
  },
  {
    field: 'name',
    headerName: 'Name',
    width: 300,
    filterable: false,
    headerClassName: headerClassName,
  },
  {
    field: 'instituteName',
    headerName: 'Institute',
    width: 400,
    filterable: false,
    headerClassName: headerClassName,
  },
  {
    field: 'collabType',
    headerName: 'Collaborator Type',
    flex: .25,
    filterable: false,
    valueGetter: (value: number, row: CollaboratorListing) => {
      return CollaboratorTypesByValue.get(row.collaboratorType)?.label
    },
    headerClassName: headerClassName,
  },
  {
    field: 'delegate',
    headerName: 'Delegate',
    flex: .25,
    filterable: false,
    valueGetter: (delegate: boolean) => delegate ? 'Y' : 'N',
    headerClassName: headerClassName,
  },
  {
    field: 'collaboratorStatus',
    headerName: 'Status',
    width: 100,
    flex: .25,
    filterable: false,
    headerClassName: headerClassName,
    renderCell: (params: AmsDataGridCellRenderParams) => {
      if (params.row.collaboratorStatus == CollaboratorStatus.Current.value) {
        return <div>{CollaboratorStatus.Current.label}</div>;
      } else {
        return <div className={"text-danger fw-bold"}>{CollaboratorStatus.Ended.label}</div>
      }
    },
  }
];
